<template>
	<v-layout class="form-perfil" wrap>
		<v-flex xs6 pr-3 mb-3>
			<label 
				class="name"
				:style="`color: ${$appColors.secondary};`">
				Contraseña anterior
			</label>
			<v-text-field
				type="password"
				label="Contraseña anterior"
				solo
				hide-details
				class="input-text"
				v-model="currentPassword"
			></v-text-field>
		</v-flex>
		<v-flex xs6 pr-3 mb-3>
			<label 
				class="name"
				:style="`color: ${$appColors.secondary};`">
				Nueva contraseña
			</label>
			<v-text-field
				type="password"
				label="Nueva contraseña"
				solo
				hide-details
				class="input-text"
				v-model="password"
			></v-text-field>
		</v-flex>
		<v-flex xs6 pr-3 mb-3>
			<label 
				class="name"
				:style="`color: ${$appColors.secondary};`">
				Repetir nueva contraseña
			</label>
			<v-text-field
				type="password"
				label="Repetir nueva contraseña"
				solo
				hide-details
				class="input-text"
				v-model="repeatPassword"
			></v-text-field>
			<span v-if="repeatPassword && (password !== repeatPassword)" class="caption" :style="`color:${$appColors.error}`">
				Las contraseñas no coinciden
			</span>
		</v-flex>
		<v-flex xs12 mt-5>
			<v-layout justify-center>
				<v-flex xs3>
					<app-button
						class="btn-form btn-red"
						:style="`background-color: ${$appColors.error};`"
						text="Cerrar"
						@click="goToUser"
					/>
				</v-flex>
				<v-flex xs3>
					<app-button
						class="btn-form btn-green"
						:disabled="isLoading || !currentPassword || !password || !repeatPassword || (password !== repeatPassword)"
						:style="`background-color: ${$appColors.success};`"
						text="Guardar"
						@click="editPassword"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
import appButton from '@/components/shared/app-button';
// import helper from '@/shared/helper';

// const { getLocalData } = helper;

async function editPassword() {
	this.isLoading = true;
	// const { company: userCompany } = getLocalData('praktiko-user') || {};
	const body = {
		// codeCompany: userCompany.code,
		currentPassword: this.currentPassword,
		password: this.password,
	};
	try {
		await this.$httpPraktiko.patch('employee/password', body);
		const text = 'La contraseña se ha cambiado correctamente.';
		this.$store.dispatch('showSnackBar', { text, color: 'success' });
	} catch (err) {
		this.$store.dispatch('showSnackBar', { text: 'Error en el servidor', color: 'error' });
	} finally {
		this.isLoading = false;
	}
}

function goToUser() {
	this.goTo('profile');
}

function data() {
	return {
		currentPassword: '',
		isLoading: false,
		password: '',
		repeatPassword: '',
	};
}

export default {
	name: 'page-password-edit',
	components: {
		appButton,
	},
	data,
	methods: {
		editPassword,
		goToUser,
	},
};
</script>
<style lang="scss" scoped>
	.form-perfil {
		align-content: flex-start;
		align-items: flex-start;
		background: color(white);
		border: 1px solid color(gray);
		border-radius: 4px;
		height: 100%;
		padding: 48px;
	}

	.btn-edit {
		background: color(success);
		border-radius: 4px;
		color: color(white);
		font-weight: 600;
		justify-content: center !important;
		padding: 5px 0;
		width: 73px;
	}

	.name {
		color: map-get($colors, secondary);
		font-size: 11px;
	}

	.btn-form {
		border-radius: 4px;
		color: color(white);
		justify-content: center !important;
		padding: 6px 0;
		width: 96px;
	}

	.btn-red {
		background: color(error);
	}

	.btn-green {
		background: color(success);
	}
</style>


// WEBPACK FOOTER //
// src/pages/user/page-password-edit.vue